import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=ebff21ca&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebff21ca')) {
      api.createRecord('ebff21ca', component.options)
    } else {
      api.reload('ebff21ca', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=ebff21ca&", function () {
      api.rerender('ebff21ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bQye5LDXI9qI/JS/comp/stardisplay.vue"
export default component.exports